function emptyCache() {
  if ("caches" in window) {
    caches.keys().then((names) => {
      // Delete all the cache files
      names.forEach((name) => {
        caches.delete(name);
      });
    });

    // Makes sure the page reloads. Changes are only visible after you refresh.
    // window.location.reload(true);
  }
}

function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

const clearData = async () => {
  if (window.sessionStorage.getItem("selected_account")) {
    window.sessionStorage.removeItem("selected_account");
  }
  await sessionStorage.clear();

  await localStorage.clear();

  await emptyCache();

  await deleteAllCookies();
};

export default clearData;